export const extractLanguage = (pathname) => {
    if (pathname.startsWith('/en')) {
      return 'en';
    }
    return 'default';
  };